import { useContactActivity, useContactNotes, useContactTasks, useContactOverdueTasks, useCreateNoteMutation, useCreateTaskMutation, useDeleteContactTaskMutation, useUpdateContactTaskMutation, useDeleteContactNoteMutation, useUpdateContactNoteMutation } from "service/crm";
import Activity from "../Activity/Activity";
import { useContactNoteComments, useContactTaskComments } from "service/crm/hooks/comments/comment";

const ContactActivity = ({ contactUuid }: { contactUuid: string }) => (
  <Activity
    entityUuid={contactUuid}
    useActivityQuery={useContactActivity}
    useNotesQuery={useContactNotes}
    useCreateNote={useCreateNoteMutation}
    buildNotePayload={(contactUuid, values) => ({
      contactUuid,
      note: values.note!.trim(),
      associatedPersonUuid: values.associatedPersonUuid,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    })}
    useUpdateNote={useUpdateContactNoteMutation}
    buildUpdateNotePayload={(contactUuid, noteUuid, values) => ({
      contactUuid,
      noteUuid,
      note: values.note!.trim(),
      associatedPersonUuid: values.associatedPersonUuid,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    })}
    useDeleteNote={useDeleteContactNoteMutation}
    buildDeleteNotePayload={(contactUuid, noteUuid) => ({
      contactUuid,
      noteUuid,
    })}
    noteCommentHooks={useContactNoteComments}
    useTasksQuery={useContactTasks}
    useOverdueTasksQuery={useContactOverdueTasks}
    useCreateTask={useCreateTaskMutation}
    buildTaskPayload={(contactUuid, values) => ({
      contactUuid,
      title: values.title!.trim(),
      description: values.description?.trim() || undefined,
      dueAt: values.dueAt,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      taskOwnerUuid: values.taskOwnerUuid,
      priority: values.priority,
      taskType: values.taskType,
      taskStatus:values.taskStatus
    })}
    useUpdateTask={useUpdateContactTaskMutation}
    buildUpdateTaskPayload={(contactUuid, taskUuid, values) => ({
      contactUuid,
      taskUuid,
      title: values.title!.trim(),
      description: values.description?.trim() || undefined,
      dueAt: values.dueAt,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      taskOwnerUuid: values.taskOwnerUuid,
      priority: values.priority,
      taskType: values.taskType,
      taskStatus:values.taskStatus
    })}
    useDeleteTask={useDeleteContactTaskMutation}
    buildDeleteTaskPayload={(contactUuid, taskUuid) => ({
      contactUuid,
      taskUuid,
    })}
    taskCommentHooks={useContactTaskComments}
  />
);

export default ContactActivity;